// extracted by mini-css-extract-plugin
module.exports = {"ChannelCellContainer":"ChannelCell_ChannelCellContainer__WYRJ4","ChannelItem":"ChannelCell_ChannelItem__MIwzx"};